import React, { useEffect, useState, useRef, useContext } from 'react'
import { fetchConsignorDetailsData, updateConsignorSetting } from '_services/accountsServices/consignorServices';
import { ButtonHeading, CommonCheckbox, CommonInput, Customdropdown, CustomSelect, NavTabs } from 'components'
import { AddButton } from 'components/common/CommonButton';
import toast from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';
import StorageService from "utils/StorageServices/StorageServices";
import LoadingBar from 'react-top-loading-bar';
import useDocumentTitle from 'hooks/useDocumentTitle';
import { constant } from 'constants/constant';
import { HiChevronDown } from 'react-icons/hi2';
import { Accordion } from 'react-bootstrap';
import { UserContext } from 'context';
import { getUser } from '_services';
import { getSupplierDetailsData, updateSupplierSetting } from '_services/accountsServices/supplierServices';
import { getAddressDetailsApi, updateAddressBookSetting } from '_services/accountsServices/addressBookService';

const SupplierSettingsTab = (props) => {

  let { name } = props;
  useDocumentTitle("Setting | T360");
  const navigate = useNavigate();
  let { id } = useParams();
  const loadingBarRef = useRef(null);

  const allKeys = ["0"];
  const [activeKeys, setActiveKeys] = useState([]);

  const toggleAll = () => {
    if (activeKeys.length === allKeys.length) {
      setActiveKeys([]);
    } else {
      setActiveKeys(allKeys);
    }
  };

  const handleToggle = (key) => {
    setActiveKeys((prevKeys) =>
      prevKeys.includes(key)
        ? prevKeys.filter((k) => k !== key)
        : [...prevKeys, key]
    );
  };

  const [formValue, setFormValue] = useState({
    is_auto_message: false,
  });
  const [loading, setLoading] = useState(false);

  const submitSettings = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      let newObj = {}
      if (name === 'addressBook') {
        newObj['addressbook_id'] = id;
        newObj['is_auto_message'] = formValue?.is_auto_message;
      } else {
        newObj['supplier_id'] = id;
        newObj['is_auto_message'] = formValue?.is_auto_message;
      }

      const res = (name === 'addressBook') ? await updateAddressBookSetting(newObj) : await updateSupplierSetting(newObj);
      if (res?.responseCode == 200) {
        toast.success(`Settings Update`);
        setLoading(false);
      } else {
        toast.error('Something went wrong, Settings Not Updated');
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      toast.error('Something went wrong, Settings Not Updated');
    }
  }

  const getDataSupplierDetails = async (id_1) => {
    try {
      if (loadingBarRef.current) {
        loadingBarRef.current.continuousStart(); // Start the loading bar
      }
      let object = {
        supplier_id: id_1,
      }
      const res = await getSupplierDetailsData(object);
      if (res?.responseCode == 200) {
        setFormValue({ is_auto_message: res?.data?.supplier?.is_auto_message })
      }
    } catch (error) {
    } finally {
      if (loadingBarRef.current) {
        loadingBarRef.current.complete(); // Complete the loading bar
      }
    }
  }

  const getDataAddressBookDetails = async (id_1) => {
    try {
      if (loadingBarRef.current) {
        loadingBarRef.current.continuousStart(); // Start the loading bar
      }
      let object = {
        addressbook_id: id_1,
      }
      const res = await getAddressDetailsApi(object);
      if (res?.responseCode == 200) {
        setFormValue({ is_auto_message: res?.data?.book_detail?.is_auto_message })
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    } finally {
      if (loadingBarRef.current) {
        loadingBarRef.current.complete(); // Complete the loading bar
      }
    }
  }

  useEffect(() => {
    if (id && StorageService.getCompanyId()) {
      if (name === 'addressBook') {
        getDataAddressBookDetails(id);
      } else {
        getDataSupplierDetails(id);
      }
    }
  }, [name, id, StorageService.getCompanyId()])

  return (
    <>
      <LoadingBar
        color="#ffa800"
        ref={loadingBarRef}
        height={4}
        shadow={true}
        loaderSpeed={1000}
      />

      <div className='__stMain'>

        <div className='__stContent'>

          <div className='__setf_brancOtr'>

            <div className='__setf_brancInner' style={{minWidth: '1100px', width: '100%'}}>
              <div className='__setf_brancBx'>
                <div className='__setf_brHead'>
                  <h4>Settings</h4>
                  {/* <span onClick={toggleAll}>
                    <HiChevronDown style={{ transform: activeKeys.length === allKeys.length ? "rotate(180deg)" : "rotate(0deg)", transition: '0.3s' }} />
                  </span> */}
                </div>

                <Accordion className='__setingAccordian' activeKey={activeKeys} alwaysOpen>

                  <Accordion.Item eventKey="0">
                    <Accordion.Header onClick={() => handleToggle("0")}> AUTO MESSAGE ON TRIP CREATEION </Accordion.Header>
                    <Accordion.Body>
                      <div className='__setf_branc_table'>
                        <table>
                          <tbody>
                            <tr>
                              <td style={{ width: '1.5%' }}>Auto Message on Trip Creation</td>
                              <td>
                                <div className='checPary_lv gap-5'>
                                  {
                                    constant.tripCreationItems?.map((el, ind) => {
                                      return (
                                        <React.Fragment key={ind}>
                                          <div className='_dualCheckr_bx'>
                                            <input
                                              className="form-check-input _avPointer"
                                              id={+ind + "is_auto_message" + el?.value}
                                              type="radio"
                                              name="is_auto_message"
                                              checked={Number(formValue?.is_auto_message) === Number(el?.value)}
                                              value={formValue?.is_auto_message ? formValue?.is_auto_message : ""}
                                              onChange={({ target: { name, value } }) =>
                                                setFormValue((s) => ({ ...s, is_auto_message: el?.value }))
                                              }
                                            />
                                            <label htmlFor={+ind + "is_auto_message" + el.value} className="form-check-label" >
                                              {el.label}
                                            </label>
                                          </div>
                                        </React.Fragment>
                                      )
                                    })
                                  }
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>

                </Accordion>
              </div>
            </div>

          </div>
        </div >
        <div className="bottomFix">
          <AddButton onClick={(e) => submitSettings(e)} name={loading ? 'Loading...' : "Save Changes"} type="button" disabled={loading} />
          <button className="_cancel_btn" onClick={(e) => navigate(-1)}> Cancel </button>
        </div>
      </div>
    </>
  )
}

export default SupplierSettingsTab